import React from 'react';

const BusinessGrowthSection = ({
  heading = "The Problem & Opportunity",
  introText = "Most donor-funded and private startup programs struggle to deliver consistent results:",
  supportText = "Here's how my team and I can support you with this:",
  offerings = [
    {
      title: "Coaches are stretched thin.",
      // description: "Award-winning programmes designed to develop entrepreneurs to stand out, scale up and make a positive impact."
    },
    {
      title: "Founders receive generic training.",
      //description: "Marketing funnel tool and platform that enables businesses to generate more data-rich leads who are more primed to buy."
    },
    {
      title: "Impact reporting feels like guesswork.",
      description: "Yet, with Ethiopia’s Startup Proclamation and the surge of regional investment, the opportunity has never been greater. Your program can become a model for measurable founder success—if you have the right delivery partner."
      
    }
  ],
  buttonText = "Find Out More",
  imageSrc = "/image_4.jpeg",
  onButtonClick = () => console.log("Find Out More clicked")
}) => {
  return (
    <div className="bg-gray-100 py-16 lg:py-20 w-full">
      <div className="w-full">
        <div className="flex flex-col lg:flex-row items-center">
          {/* Left Side - Image */}
          <div className="lg:w-1/2">
            <img
              src={imageSrc}
              alt="Business Growth Discussion"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>
          
          {/* Right Side - Text Content */}
          <div className="lg:w-1/2 space-y-6 px-4 sm:px-6 lg:px-12">
            {/* Main Heading */}
            <h2 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-800 leading-tight">
              {heading}
            </h2>
            
            {/* Accent Line */}
            <div className="w-16 h-1 bg-accent-yellow"></div>
            
            {/* Introductory Text */}
            <div className="space-y-4">
              <p className="text-gray-700 text-lg leading-relaxed">
                {introText}
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                {supportText}
              </p>
            </div>
            
            {/* Offerings List */}
            <div className="space-y-4">
              {offerings.map((offering, index) => (
                <div key={index} className="flex items-start space-x-3">
                  {/* Arrow Icon */}
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-5 h-5 text-accent-yellow" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                  
                  {/* Content */}
                  <div>
                    <h3 className="font-semibold text-gray-800 text-lg mb-1">
                      {offering.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed" style={{ whiteSpace: 'pre-line' }}>
                      {offering.description ? offering.description.replace(/<br\s*\/?>(\r?\n)?/gi, '\n') : ''}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessGrowthSection;
